/**
 * @desc undefined
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DeleteBankParameter = {
  id?: string
}

const method = 'DELETE'
const url = '/finance/bank'

export const deleteBankApi = (
  params?: DeleteBankParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

deleteBankApi.method = method
deleteBankApi.url = url
